import fontSizes from './fontsizes';
import fontWeights from './fontweights';
import typography from './typography';
export * from './typography.types';

export default typography;
export { fontWeights, fontSizes };
